<template>
  <div style="position: relative">
    <div
      v-if="disabled"
      id="tree-overlay"
    />
    <div class="row">
      <v-treeview
        v-model="treeValue"
        :item-children="itemChildren"
        :item-disabled="shutoff"
        :item-key="itemKey"
        :item-text="itemText"
        :items="treeViewItems"
        :open="openNodeIds"
        :open-all="openAll"
        :return-object="returnObject"
        activatable
        active-class="white"
        collapse-icon="fa-caret-right"
        expand-icon="fa-caret-down"
        indeterminate-icon="fa-minus-square"
        off-icon="fa-square"
        on-icon="fa-check-square"
        :transition="false"
        :selectable="selectable"
        selected-color="#e72b37"
      >
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </v-treeview>
      <v-autocomplete
        v-if="displayFeiertagsRegionImport"
        class="col-6 float-right"
        :value="[]"
        :items="publichHolidayRegionOptions"
        item-text="title"
        return-object
        @change="handlePublicHolidayRegionSeleted"
      />
    </div>
  </div>
</template>

<script>
import { GetPublicHolidayRegions } from "@/services/minimum.wage.services/publicholidayRegions.minimum.wage";

export default {
  props: {
    treeViewItems: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    openNodeIds: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    itemKey: {
      type: String,
      default: "id",
    },
    itemText: {
      type: String,
      default: "name",
    },
    itemChildren: {
      type: String,
      default: "children",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    openAll: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    displayFeiertagsRegionImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shutoff: "shutoff",
      publichHolidayRegionOptions: [],
    };
  },
  computed: {
    treeValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    displayFeiertagsRegionImport() {
      this.LoadPublichHolidayRegionOptions();
    },
  },
  created() {
    this.LoadPublichHolidayRegionOptions();
  },
  methods: {
    handleChanged() {
      this.$emit("change");
    },
    LoadPublichHolidayRegionOptions() {
      if (!this.displayFeiertagsRegionImport) {
        return;
      }

      GetPublicHolidayRegions(
        (response) => {
          this.publichHolidayRegionOptions = response;
        },
        (error) => {
          console.error(error);
        },
      );
    },
    handlePublicHolidayRegionSeleted(region) {
      this.treeValue = [
        ...this.treeValue,
        ...region.locations.map((location) => location.path),
      ];
    },
  },
};
</script>

<style>
.v-treeview-node__label {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-treeview-node__content {
  width: 90%;
}

.v-treeview-node__toggle {
  z-index: 20 !important;
}

#tree-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  opacity: 0.5;
  background-color: white;
}
</style>
